import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, DollarSign, UserCheck, AlertTriangle } from "lucide-react";
import { format } from "date-fns";

interface CustomerSummaryProps {
  data: any[];
}

export function CustomerSummary({ data }: CustomerSummaryProps) {
  const totalCustomers = data.length;
  const totalRevenue = data.reduce((acc, customer) => {
    const customerRevenue = customer.transactions?.reduce(
      (sum: number, transaction: any) =>
        transaction.type === "entrada" ? sum + Number(transaction.amount) : sum,
      0
    );
    return acc + (customerRevenue || 0);
  }, 0);

  const activeCustomers = data.filter((customer) => {
    const lastTransaction = customer.transactions?.sort(
      (a: any, b: any) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    )[0];
    return (
      lastTransaction &&
      new Date(lastTransaction.created_at) >
        new Date(Date.now() - 90 * 24 * 60 * 60 * 1000)
    );
  }).length;

  const debtorsCount = data.filter((customer) =>
    customer.transactions?.some(
      (t: any) =>
        t.payment_status === "pendente" || t.payment_status === "atrasado"
    )
  ).length;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total de Clientes</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalCustomers}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Receita Total</CardTitle>
          <DollarSign className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(totalRevenue)}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Clientes Ativos</CardTitle>
          <UserCheck className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{activeCustomers}</div>
          <p className="text-xs text-muted-foreground">
            Últimos 90 dias
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Inadimplentes</CardTitle>
          <AlertTriangle className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{debtorsCount}</div>
        </CardContent>
      </Card>
    </div>
  );
}